// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"427":"840ffba1","462":"cbb7390a","624":"a7794b93","712":"c5a882cd","785":"4116148a","791":"15cf8b59","793":"679a8582","831":"452bc75c","914":"ec779dd1","958":"d4633e3b"}[chunkId] + ".chunk.js";
};